// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AirlineTripsTable {
  --row-color-dep: rgb(255, 255, 255);
  --row-color-arr: rgb(242, 242, 242);
  --row-color-spl: rgb(207, 231, 255);
  --row-color-late: rgb(234, 243, 191);
  --row-color-deleted: rgb(255, 255, 255);
  --row-color-cancelled: rgb(255, 216, 177);
  --row-color-curbside: rgb(255, 220, 220);
  --cell-pulse-color: rgba(197, 197, 197, 0.5);
}
.AirlineTripsTable .SimpleTable-Row.DEP {
  background-color: var(--row-color-dep);
}
.AirlineTripsTable .SimpleTable-Row.ARR {
  background-color: var(--row-color-arr);
}
.AirlineTripsTable .SimpleTable-Row.DEP.UPCOMING:not(.DELETED):not(.CANCELLED):not(.COMPLETED) > .UNASSIGNED, .AirlineTripsTable .SimpleTable-Row.ARR.UPCOMING:not(.DELETED):not(.CANCELLED):not(.COMPLETED) > .UNASSIGNED {
  animation: pulse 1s ease-in-out infinite !important;
}
.AirlineTripsTable .SimpleTable-Row.DEP:not(.ARR).LATE, .AirlineTripsTable .SimpleTable-Row.ARR:not(.PICKEDUP):not(.ARR).LATE {
  background-color: var(--row-color-late);
}
.AirlineTripsTable .SimpleTable-Row.DEP.SPL, .AirlineTripsTable .SimpleTable-Row.ARR:not(.PICKEDUP).SPL {
  background-color: var(--row-color-spl);
}
.AirlineTripsTable .SimpleTable-Row.DEP.CANCELLED, .AirlineTripsTable .SimpleTable-Row.ARR:not(.PICKEDUP).CANCELLED {
  background-color: var(--row-color-cancelled);
}
.AirlineTripsTable .SimpleTable-Row.DEP.CURBSIDE, .AirlineTripsTable .SimpleTable-Row.ARR:not(.PICKEDUP).CURBSIDE {
  background-color: var(--row-color-curbside);
}
.AirlineTripsTable .SimpleTable-Row.DEP.DELETED, .AirlineTripsTable .SimpleTable-Row.ARR:not(.PICKEDUP).DELETED {
  background-color: var(--row-color-deleted);
}
.AirlineTripsTable .SimpleTable-Row.DEP.DELETED:after, .AirlineTripsTable .SimpleTable-Row.ARR:not(.PICKEDUP).DELETED:after {
  content: "";
  width: calc(100% - 8px);
  height: 0.3rem;
  background-color: var(--bs-secondary-subtle);
  opacity: 0.5;
  position: absolute;
  top: calc(50% - 0.155rem);
  left: 4px;
  z-index: 1;
  pointer-events: none;
}
.AirlineTripsTable .SimpleTable-Row .Flags {
  position: relative;
  vertical-align: text-top;
}
.AirlineTripsTable .SimpleTable-Row .Flags > i {
  font-size: 1.25rem;
}
.AirlineTripsTable .SimpleTable-Row .Flags > i.sv-flag-filled {
  position: absolute;
  text-shadow: 1px 0 1px rgba(0, 0, 0, 0.5);
}
.AirlineTripsTable .SimpleTable-Row .Flags > .badge {
  position: absolute;
  transform: scale(0.7);
  border-radius: 50%;
}
.AirlineTripsTable .Dropdown input[name^=driver_],
.AirlineTripsTable .Dropdown input[name^=vehicle_] {
  border: none;
  background-color: transparent;
}
.AirlineTripsTable .Dropdown input[name^=driver_]:focus, .AirlineTripsTable .Dropdown input[name^=driver_]:active,
.AirlineTripsTable .Dropdown input[name^=vehicle_]:focus,
.AirlineTripsTable .Dropdown input[name^=vehicle_]:active {
  outline: none;
  border: none;
  box-shadow: none;
}
.AirlineTripsTable .Dropdown input[name^=driver_]::placeholder,
.AirlineTripsTable .Dropdown input[name^=vehicle_]::placeholder {
  color: black !important;
}
.AirlineTripsTable .SimpleTable-Footer {
  display: flex;
  gap: 1rem;
  padding: 1rem 0;
}
.AirlineTripsTable .SimpleTable-Footer button {
  width: 12rem;
}
@keyframes pulse {
  0% {
    background-color: var(--cell-pulse-color);
  }
  50% {
    background-color: transparent;
  }
  100% {
    background-color: var(--cell-pulse-color);
  }
}

@media print {
  .TripsTable .fa.fa-circle-info {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/AirlineTrips/components/TripsTable/styles.scss"],"names":[],"mappings":"AAQA;EACE,mCAAA;EACA,mCAAA;EACA,mCAAA;EACA,oCAAA;EACA,uCAAA;EACA,yCAAA;EACA,wCAAA;EACA,4CAAA;AAPF;AAWI;EACE,sCAAA;AATN;AAYI;EACE,sCAAA;AAVN;AAiBQ;EACE,mDAAA;AAfV;AAyBQ;EACE,uCAAA;AAvBV;AA2BM;EACE,sCAAA;AAzBR;AA4BM;EACE,4CAAA;AA1BR;AA6BM;EACE,2CAAA;AA3BR;AA8BM;EACE,0CAAA;AA5BR;AA6BQ;EACE,WAAA;EACA,uBAAA;EACA,cAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;AA3BV;AA+BI;EACE,kBAAA;EACA,wBAAA;AA7BN;AA8BM;EACE,kBAAA;AA5BR;AA6BQ;EACE,kBAAA;EACA,yCAAA;AA3BV;AA8BM;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AA5BR;AAkCI;;EAEE,YAAA;EACA,6BAAA;AAhCN;AAiCM;;;EAEE,aAAA;EACA,YAAA;EACA,gBAAA;AA9BR;AAgCM;;EACE,uBAAA;AA7BR;AAkCE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAhCJ;AAkCI;EACE,YAAA;AAhCN;AAmCE;EACE;IACE,yCAAA;EAjCJ;EAoCE;IACE,6BAAA;EAlCJ;EAqCE;IACE,yCAAA;EAnCJ;AACF;;AAuCA;EAEI;IACE,aAAA;EArCJ;AACF","sourcesContent":["$WHITE: rgba(255, 255, 255, 1);\n$GREY: rgba(242, 242, 242, 1);\n$BLUE: rgba(207, 231, 255, 1);\n$LIGHT_GREEN: rgba(234, 243, 191, 1);\n$LIGHT_RED: rgba(255, 220, 220, 1);\n$ORANGE: rgba(255, 216, 177, 1);\n$PULSE: rgba(197, 197, 197, 0.5);\n\n.AirlineTripsTable {\n  --row-color-dep: #{$WHITE};\n  --row-color-arr: #{$GREY};\n  --row-color-spl: #{$BLUE};\n  --row-color-late: #{$LIGHT_GREEN};\n  --row-color-deleted: #{$WHITE};\n  --row-color-cancelled: #{$ORANGE};\n  --row-color-curbside: #{$LIGHT_RED};\n  --cell-pulse-color: #{$PULSE};\n\n  .SimpleTable-Row {\n    // DEPARTURE (Outbound)\n    &.DEP {\n      background-color: var(--row-color-dep);\n    }\n    // ARRIVAL (Inbound)\n    &.ARR {\n      background-color: var(--row-color-arr);\n    }\n    // OUTBOUND & INBOUND\n    &.DEP,\n    &.ARR {\n      // UPCOMING not DELETED, CANCELLED, or COMPLETED\n      &.UPCOMING:not(.DELETED):not(.CANCELLED):not(.COMPLETED) {\n        > .UNASSIGNED {\n          animation: pulse 1s ease-in-out infinite !important;\n        }\n      }\n    }\n    // OUTBOUND & INBOUND (NOT PICKED UP)\n    &.DEP,\n    &.ARR:not(.PICKEDUP) {\n      // OUTBOUND\n      &:not(.ARR) {\n        // LATE\n        &.LATE {\n          background-color: var(--row-color-late);\n        }\n      }\n      // SPECIAL\n      &.SPL {\n        background-color: var(--row-color-spl);\n      }\n      // CANCELLED\n      &.CANCELLED {\n        background-color: var(--row-color-cancelled);\n      }\n      // CURBSIDE\n      &.CURBSIDE {\n        background-color: var(--row-color-curbside);\n      }\n      // DELETED\n      &.DELETED {\n        background-color: var(--row-color-deleted);\n        &:after {\n          content: '';\n          width: calc(100% - 8px);\n          height: 0.3rem;\n          background-color: var(--bs-secondary-subtle);\n          opacity: 0.5;\n          position: absolute;\n          top: calc(50% - 0.155rem);\n          left: 4px;\n          z-index: 1;\n          pointer-events: none;\n        }\n      }\n    }\n    .Flags {\n      position: relative;\n      vertical-align: text-top;\n      > i {\n        font-size: 1.25rem;\n        &.sv-flag-filled {\n          position: absolute;\n          text-shadow: 1px 0 1px rgba(0, 0, 0, 0.5);\n        }\n      }\n      > .badge {\n        position: absolute;\n        transform: scale(0.7);\n        border-radius: 50%;\n      }\n    }\n  }\n\n  .Dropdown {\n    input[name^='driver_'],\n    input[name^='vehicle_'] {\n      border: none;\n      background-color: transparent;\n      &:focus,\n      &:active {\n        outline: none;\n        border: none;\n        box-shadow: none;\n      }\n      &::placeholder {\n        color: black !important;\n      }\n    }\n  }\n\n  .SimpleTable-Footer {\n    display: flex;\n    gap: 1rem;\n    padding: 1rem 0;\n\n    button {\n      width: 12rem;\n    }\n  }\n  @keyframes pulse {\n    0% {\n      background-color: var(--cell-pulse-color);\n    }\n\n    50% {\n      background-color: transparent;\n    }\n\n    100% {\n      background-color: var(--cell-pulse-color);\n    }\n  }\n}\n\n@media print {\n  .TripsTable {\n    .fa.fa-circle-info {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
